import { render, staticRenderFns } from "./DiscussionForum.vue?vue&type=template&id=12be34bf&scoped=true&"
import script from "./DiscussionForum.vue?vue&type=script&lang=js&"
export * from "./DiscussionForum.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionForum.vue?vue&type=style&index=0&id=12be34bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be34bf",
  null
  
)

export default component.exports